module.exports = __webpack_public_path__ + "assets/89de9101b10a3fd497fef480319ff743.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-500-normal.woff2
// module id = 2628
// module chunks = 121